import get from "lodash.get";

/**
 * Standalone donation kill-switch (GR-3597).
 *
 * When the campaign template flag
 * `template.value.customSetup.standalone.useLegacyDonationBehaviour` is `true`,
 * the card flows fall back to the legacy synchronous token API
 * (`createToken` → `/api/v2/donation` and `/api/v2/donationSubscription`).
 * `false` / `null` / absent → the new PaymentIntent / SetupIntent behaviour (default).
 *
 * Only an explicit `true` opts into legacy.
 */
export const isLegacyDonationBehaviour = (page) =>
  get(page, "campaign.template.value.customSetup.standalone.useLegacyDonationBehaviour") === true;

/**
 * MOTO (agent-assisted) checkout, driven by the campaign's admin "Use Moto" toggle
 * (exposed publicly as `campaign.donationSetup.paymentUseMoto`).
 *
 * Stripe accepts the moto option only alongside a confirmation, so on MOTO campaigns the
 * card becomes a PaymentMethod client-side and the API confirms the intent server-side on
 * creation; the client skips its confirmCardPayment step.
 */
export const isMotoDonation = (page) =>
  get(page, "campaign.donationSetup.paymentUseMoto") === true;
